import {
  instance,
  multipartJwtToken,
  setJwtToken,
} from "../../config/axiosInstance";
import { toast } from "react-toastify";

// Fetching Retailer List Api
export const sellerListController = async (
  activePage = 1,
  filterByStatus = null,
  search = "",
  filterByDate = "",
  limit
) => {
  try {
    const params = {};
    params.page = activePage;
    params.status = filterByStatus;
    params.search = search;
    params.date = filterByDate ? filterByDate : "";
    params.limit = limit;
    // console.log(params, "params");
    const data = await instance.get(`admin/seller-list`, {
      params,
      ...setJwtToken(),
    });
    if (data?.data?.code === 200) {
      return data?.data;
    } else {
      toast.error(data?.response?.data?.message || data?.data?.message);
      return data?.data;
    }
  } catch (e) {
    toast.error("An error occurred during fetching retailer list.");
    return null;
  }
};

// seller product link api 
export const createSellerProductRelation = async (sellerId, productId) => {
  try {
    const data = await instance.post(
      `admin/seller/add-product`,
      { sellerId, productId },
      setJwtToken()
    );

    if (data?.data?.code === 200) {
      return data.data;
    } else {
      return data.data;
    }
  } catch (error) {
    toast.error("An error occurred while linking seller and product.");
    return { success: false, message: error.message };
  }
};


// fetch seller product relation
export const getSellersProductController = async (
  activePage = 1,
 // sellerId = null,
  search = "",
  filterByDate = "",
  limit
) => {
  try {
    const params = {};
    params.page = activePage;
    params.search = search;
    params.date = filterByDate ? filterByDate : "";
    params.limit = limit ;

    // if (sellerId) {
    //   params.sellerId = sellerId;
    // }

    const data = await instance.get(`admin/seller/product-list`, {
      params,
      ...setJwtToken(),
    });

    if (data?.data?.code === 200) {
      return data?.data;
    } else {
      toast.error(data?.response?.data?.message || data?.data?.message);
      return data?.data;
    }
  } catch (e) {
    toast.error("An error occurred while fetching seller's products.");
    return null;
  }
};

// Fetching Retailer Add Api
export const addSellerController = async (reqData) => {
  const data = await instance.post(
    `admin/create-seller`,
    reqData,
    multipartJwtToken()
  );
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

// Seller Product Relation Api
export const sellerRelationController = async (reqData) => {
  const data = await instance.post(
    `admin/seller/product-list`,
    reqData,
    multipartJwtToken()
  );
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

// Fetching Retailer Detail Api
export const sellerDetailController = async (id) => {
  const data = await instance.get(
    `admin/seller-detail?id=${id}`,
    setJwtToken()
  );
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

// Fetching Retailer Status Change API
export const sellerStatusChangeController = async (id) => {
  const data = await instance.post(
    `admin/update-seller-status`,
    { id: id },
    setJwtToken()
  );
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

// Fetching Request List API
export const requestListController = async (
  activePage,
  search,
  limit,
  filterByDate
) => {
  const params = {};
  params.page = activePage ? activePage : "";
  params.search = search ? search : "";
  params.limit = limit ? limit : "";
  params.date = filterByDate ? filterByDate : "";

  const data = await instance.get(`admin/retailer-requests-list`, {
    params,
    ...setJwtToken(),
  });
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

// Fetching Retailer List Without Pagination API
export const retailerListWithoutPaginationController = async () => {
  try {
    const data = await instance.get(`admin/retailer-list-without-pagination`, {
      ...setJwtToken(),
    });

    if (data?.data?.code === 200) {
      return data?.data;
    } else {
      toast.error(data?.response?.data?.message || data?.data?.message);
      return data?.data;
    }
  } catch (e) {
    toast.error("An error occurred during fetching retailer list.");
    return null;
  }
};

//Fetching Request Detail API
export const requestDetailController = async () => {
  const data = await instance.get(
    `admin/retailer-requests-list`,
    setJwtToken()
  );
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

export const editSellerDetailsController = async (reqData) => {
  // console.log("API hitting");
  const data = await instance.post(
    `admin/update-seller`,
    reqData,
    multipartJwtToken()
  );
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

// Delete Scheme Controller
export const deleteSellerController = async (reqData) => {
  console.log("reqData", reqData);
  const data = await instance.post(
    `admin/seller-delete`,
    reqData,
    setJwtToken()
  );
  return data;
};

// Delete seller product relation
export const deleteSellerProductRelationController = async (reqData) => {
  console.log("reqData", reqData);
  const data = await instance.post(
    `admin/seller/product-delete`,
    reqData,
    setJwtToken()
  );
  return data;
};


//Fetching Approve Retailer APi
export const approveRetailerController = async (id) => {
  try {
    const { data } = await instance.post(
      `admin/approve-retailer`,
      { id: id },
      setJwtToken()
    );
    return data;
  } catch (e) {
    toast.error("An error occured during fetching request detail");
    return null;
  }
};

//Fetching Reject Retailer APi
export const rejectRetailerController = async (reqData) => {
  try {
    const { data } = await instance.post(
      `admin/reject-retailer`,
      { id: reqData.id, reason: reqData.reason },
      setJwtToken()
    );
    return data;
  } catch (e) {
    toast.error("An error occured during fetching request detail");
    return null;
  }
};

// Fetching OwnerShip Type Api
export const ownershipTypeController = async () => {
  try {
    const { data } = await instance.get(`admin/ownership-list`, setJwtToken());
    return data;
  } catch (e) {
    toast.error("An error occured during fetching OwnerShip");
    return null;
  }
};

// Fetching Orders List API
export const orderListController = async (id, status) => {
  try {
    const params = {};
    params.retailerId = id;
    params.status = status;
    const { data } = await instance.get(`admin/user-order-detail`, {
      params,
      ...setJwtToken(),
    });
    return data;
  } catch (e) {
    toast.error("An error occured during fetching Order List");
    return null;
  }
};

// Fetching License Forms API
export const licenseFormsController = async () => {
  const data = await instance.get(`api//licence-list`, setJwtToken());
  if (data?.data?.code === 200) {
    return data.data;
  } else {
    toast.error(data?.response?.data?.message || data?.data?.message);
    return data.data;
  }
};

//Fetching Approve Retailer APi
export const approveUserRequestController = async (id) => {
  try {
    const data = await instance.post(
      `admin/approve-users-request
      `,
      { userId: id },
      setJwtToken()
    );
    return data;
  } catch (e) {
    toast.error(e.message);
    return null;
  }
};

// Fetching Delete Request List Api
export const deleteRequestListController = async (page, limit, search) => {
  const params = {
    page: page,
    limit: limit,
    search: search,
  };
  const data = await instance.get(`admin/user-delete-requests`, {
    params,
    ...setJwtToken(),
  });
  return data;
};

export const archivedSeller = async (id)=>{
  try {
    const data = await instance.post(
      `admin/archive-seller`,
      {id:id},
      setJwtToken()
    );
    return data;
  } catch (e) {
    toast.error(e.message);
    return null;
  }
}

export const getArchivedSeller = async (
  activePage = 1,
  search = "",
  filterByDate = "",
  limit
)=>{
  try {
    const params = {};
    params.page = activePage;
    params.search = search;
    params.date = filterByDate ? filterByDate : "";
    params.limit = limit;
    const data = await instance.get(
      `admin/list-archived-sellers`,
      {
        params,
        ...setJwtToken()
      }
    );
    return data;
  } catch (e) {
    toast.error(e.message);
    return null;
  }
}